module.exports = __webpack_public_path__ + "img/moeda.1f714118.png";